import { useMutation } from '@tanstack/react-query'

import { abuseApi } from '../api/abuseApi'
import type { TReportAbusePayload } from '../api/types/reportAbuse'
import type { ABUSE_TYPE } from '../models/Abuse.enums'

export type TUseReportAbuseProps = {
  objectType: ABUSE_TYPE
  objectId: number
  onSuccess?: VoidFunction
}

export const useReportAbuseMutation = ({ objectId, objectType, onSuccess }: TUseReportAbuseProps) =>
  useMutation({
    mutationFn: (payload: TReportAbusePayload) => abuseApi.reportAbuse(objectType, objectId, payload),
    onSuccess,
  })
